import React from "react"
import useMediaQuery from "@material-ui/core/useMediaQuery"

import FooterLinkCentering from "molecules/FooterLinkCentering"
import FooterLinkLeftAdjust from "molecules/FooterLinkLeftAdjust"

const Footer = () => {
  return useMediaQuery("(min-width:600px)") ? (
    <FooterLinkCentering />
  ) : (
    <FooterLinkLeftAdjust />
  )
}

export default Footer
